// extracted by mini-css-extract-plugin
export default {"dropDownLabel":"display-settings-dropDownLabel-qNcfl_","dropDown":"display-settings-dropDown-IYvg4q","preview":"display-settings-preview-kuLnfG"};